<template>
  <div class="page-header">
    <div class="page-header__container">
      <div class="page-header__back-icon">
        <i
          v-if="showBackIcon"
          class="el-icon-back mousepointer"
          @click="handleBackClick">
        </i>
      </div>
      <div class="page-header__title" data-test="page-header__title">
        {{ title }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: { type: String, required: true },
    showBackIcon: { type: Boolean, default: false },
  },
  methods: {
    handleBackClick() {
      this.$emit('back');
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '../../assets/css/main.styl';

.mousepointer {
  cursor: pointer;
}

.page-header {
  width: 100%;
  height: 90px;
  background: $secondary-color;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.page-header__back-icon {
  color: white;
  font-size: 30px;
  margin-right: 20px;
}

.page-header__container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  width: 100%;
  height: 100%;
}

.page-header__title {
  color: #fff;
  font-size: $main-title-size;
}
</style>
